import React from 'react';
import { Alert, Box, IconButton, Collapse } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { UserDetailsDto } from '../../types/UserDetailsDto';

interface ExpirationWarningProps {
  user: UserDetailsDto;
  open: boolean;
  onClose: () => void;
}

const ExpirationWarning: React.FC<ExpirationWarningProps> = ({ user, open, onClose }) => {
  if (!user.expirationDate) return null;

  const expirationDate = new Date(user.expirationDate);
  const now = new Date();
  const daysUntilExpiration = Math.ceil((expirationDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  if (daysUntilExpiration > 7) return null;

  let message = '';
  let severity: 'warning' | 'error' = 'warning';

  if (daysUntilExpiration <= 0) {
    severity = 'error';
    message = 'Your account has expired. Please contact support to renew your subscription.';
  } else {
    message = `Your account will expire in ${daysUntilExpiration} ${daysUntilExpiration === 1 ? 'day' : 'days'}. Please renew your subscription.`;
  }

  return (
    <Collapse in={open}>
      <Box
        sx={{
          position: 'fixed',
          top: 72, // 64px app bar + 8px gap
          right: 24, // adjust as needed to align with user menu
          zIndex: 2000,
          width: 'auto',
          maxWidth: 600,
          pointerEvents: 'none',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Alert
          severity={severity}
          variant="outlined"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={onClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{
            borderRadius: 2,
            fontSize: '0.95rem',
            py: 0.5,
            minHeight: 0,
            backgroundColor: severity === 'warning'
              ? 'rgba(255, 244, 229, 0.85)'
              : 'rgba(255, 235, 238, 0.85)',
            color: severity === 'warning'
              ? '#8a6d3b'
              : '#a94442',
            border: '1px solid #ffe0b2',
            width: '100%',
            pointerEvents: 'auto',
            boxShadow: 4,
          }}
        >
          {message}
        </Alert>
      </Box>
    </Collapse>
  );
};

export default ExpirationWarning; 